import { Action, Module, VuexModule } from 'vuex-module-decorators'

import store from '@/store'
import { Pagination } from '@/models/General'
import { getAdminCustomerUser, getAdminCustomerUsers } from '@/api/customers'
import { ModelPayload, ParamsPayload } from '@/models/Payloads'
import { CustomerItem } from '@/models/Customer'

export const CUSTOMER_MODULE_NAME = 'customer'

@Module({
  namespaced: true,
  store,
  name: CUSTOMER_MODULE_NAME
})
export class CustomerModule extends VuexModule {
  constructor () {
    super(VuexModule)
  }

  @Action({ rawError: true })
  public async fetchAdminCustomerUsers (payload: ModelPayload): Promise<Pagination> {
    return new Promise((resolve, reject) => {
      getAdminCustomerUsers(payload)
        .then(response => {
          if (response && response.data && response.data.customers) {
            const customersPagination: Pagination = response.data.customers
            resolve(customersPagination)
          }
        })
        .catch(error => {
          // console.log('Error message : ', error.response)
          reject(error)
        })
    })
  }

  @Action({ rawError: true })
  public async fetchAdminCustomerUser (payload: ModelPayload): Promise<CustomerItem> {
    return new Promise((resolve, reject) => {
      getAdminCustomerUser(payload)
        .then(response => {
          if (response && response.data && response.data.customer) {
            const customer: CustomerItem = response.data.customer
            resolve(customer)
          }
        })
        .catch(error => {
          // console.log('Error message : ', error.response)
          reject(error)
        })
    })
  }
}
